import React from 'react';

const Uganda1_mature_entry_eng = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_mature_entry_eng;
